import React from "react"
import styled, { keyframes } from "styled-components/macro"
import MaskImage from "./itemImage"
import { ImageBox, ViewRow } from "./styled/styles"

const float = keyframes`
	0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-10px);
	}
	100% {
		transform: translatey(0px);
	}
`
const fadeInBottom = keyframes`
  0% {
    opacity: 0;
    transform: translateY(100%)
  }
  100% {
    opacity: 1;
  }
`
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`
const ExpandedBox = styled.div`
  width: auto;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: max-height;
  background: ${({ theme }) => theme.expandedBackground};
  border-radius: 34px;
  opacity: 1;
  padding: 3px;
  margin: 0 16px;
  animation: ${fadeInBottom} 1s ease-in-out;
  @media (min-width: 961px) {
    position: sticky;
    top: 16px;
  }

  @media (max-width: 960px) {
    flex: 1;
    position: relative;
  }
`

const Title = styled.h2`
  font-weight: 800;
  font-size: 18px;
  text-align: center;
  color: ${({ theme }) => theme.headerSubtitle};
  margin: 16px 0 0 0;
`
const Description = styled.h3`
  font-size: 12px;
  color: ${({ theme }) => theme.description};
  opacity: 0.5;
  text-align: center;
  white-space: pre-wrap;
  margin: 4px 21px;
  font-weight: 500;
`
const Glyph = styled.img`
  animation: ${rotate} 15s linear infinite;
  margin: 0;
  max-width: 190px;
  max-height: 190px;
  width: 190px;
  height: 190px;
  padding: 0;
  margin: 0;
  filter: drop-shadow(0px 0px 2px #fff);
`
const SubDescription = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.description};
  opacity: 0.54;
  text-align: center;
  font-style: italic;
  padding: 0 21px;
  margin: 0 0 16px 0;
  line-height: 1.2;
`
const ImageContainer = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`
const FloatContainer = styled.div`
  position: absolute;
  display: inline-block;
  width: auto;
  height: auto;
  animation: ${float} 6s ease-in-out infinite;
  margin: 0;
`
const StatsBox = styled.div`
  width: 100%;
  height: auto;
  flex: 1;
  background: ${({ theme }) => theme.statsBackground};
  border-radius: 32px;
  padding: 24px;
  margin-top: 15px;
`
const Stats = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 12px;
  justify-content: space-between;
  margin: 0 0 8px 0;
  &:last-child {
    margin: 0;
  }
`
const StatName = styled.p`
  font-weight: bold;
  color: ${({ theme }) => theme.description};
  text-align: left;
  opacity: 0.65;
  margin: 0;
`
const Value = styled.p`
  font-weight: normal;
  color: ${({ theme }) => theme.description};
  text-align: right;
  margin: 0;
`

export default props => {
  return (
    <ExpandedBox theme={props.theme}>
      <ImageContainer>
        <Glyph src={require("../images/Weapons/Glyph.png")} />
        <FloatContainer>
          <img
            src={require(`../images/${props.type}/${props.currentSkin.name
              .toLowerCase()
              .split(" ")
              .join("")
              .replace("!", "")}.png`)}
            alt={props.currentSkin.name}
            css={`
              width: auto;
              height: 275px;
              margin: 0;
            `}
          />
        </FloatContainer>
      </ImageContainer>
      {props.data.skins ? (
        <ViewRow>
          {props.data.skins.map((skin, index) => (
            <ImageBox
              key={index}
              active={props.currentSkin === skin}
              onClick={() => {
                props.setCurrentSkin(props.currentSkin === index ? null : skin)
              }}
              css={`
                border: 2px solid #ffffffab;
                padding: 8px;
                border-radius: 16px;
                cursor: pointer;
                margin: 46px 8px 0 0;
                background: ${({ active }) => (active ? "white" : "transparent")};
              `}
            >
              <MaskImage
                key={index}
                theme={props.theme}
                filename={`${skin.name.toLowerCase().split(" ").join("").replace("!", "")}mask`}
                alt={skin.name}
                style={{
                  margin: 0,
                  width: "35px",
                  height: "40px",
                }}
              />
            </ImageBox>
          ))}
        </ViewRow>
      ) : null}
      <Title theme={props.theme}>{props.currentSkin.name} </Title>
      <Description theme={props.theme}>{props.currentSkin.description}</Description>
      {props.currentSkin.quote ? <SubDescription>{props.currentSkin.quote}</SubDescription> : null}
      <StatsBox theme={props.theme}>
        {props.currentSkin.stats.map((stat, index) => (
          <Stats theme={props.theme} key={index}>
            <StatName theme={props.theme}>{stat.name}</StatName>
            <Value theme={props.theme}>{stat.value}</Value>
          </Stats>
        ))}
      </StatsBox>
    </ExpandedBox>
  )
}
